export enum UserRoutesNamesEnum {
  user = 'user',
  billingAddress = 'billing-address',
  changePassword = 'change-password',
  personalInformation = 'personal-information'
}
